import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './components/api'; // Side-effect: instala interceptor global de fetch + auth
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

/**
 * O mock (mockHandlers + mockDb, ~900 linhas de dados fictícios) era importado
 * de forma estática. A guarda impedia a EXECUÇÃO, mas por ser import com efeito
 * colateral o webpack não conseguia removê-lo: e-mails internos, nomes e grupos
 * de exemplo ficavam legíveis no bundle de produção.
 *
 * A comparação está inline de propósito, NÃO extraída para uma constante: o
 * webpack substitui `process.env.REACT_APP_MOCK_MODE` por literal ainda na
 * análise do módulo e, vendo `if ('undefined' === 'true')`, descarta o ramo
 * inteiro — inclusive o import(). Com a checagem numa constante ele até elimina
 * o código, mas ainda emite o chunk do mock no build.
 *
 * O await é obrigatório: o mock precisa envolver o fetch — já interceptado por
 * ./components/api acima — ANTES do primeiro render, senão as chamadas iniciais
 * escapam para a rede real.
 */
async function boot() {
  if (process.env.REACT_APP_MOCK_MODE === 'true') {
    await import('./components/mockHandlers');
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

boot();

serviceWorkerRegistration.register({
  onUpdate: () => {
    if (process.env.NODE_ENV === 'development') {
      console.log('[SW] Nova versão detectada, atualizando...');
    }
  },
  onSuccess: () => {
    if (process.env.NODE_ENV === 'development') {
      console.log('[SW] Aplicação pronta para funcionar offline.');
    }
  },
});
